import { FC, useEffect, useState } from "react";
import { SelectComponentsProps } from "./types";
import {
  useWidgetStore,
  usePopupStore,
  useThemeStore,
} from "../../../../stores";
import { Column } from "../../../../components/containers";
import { PopupClose } from "../../../../popup";
import { Heading } from "../../../../components/typography";
import { WIDGETS } from "../../../../constants/widgets";
import { CheckBox } from "../../../../components/inputs";
import { AlignItems } from "../../../../components/containers/types";

const SelectComponents: FC<SelectComponentsProps> = ({ item }) => {
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const theme = useThemeStore((s) => s.theme);
  const addWidgetToItem = useWidgetStore((s) => s.addWidgetToItem);
  const rmWidgetFromItem = useWidgetStore((s) => s.rmWidgetFromItem);
  const getWidgetByName = useWidgetStore((s) => s.getWidgetByName);
  const clearItemWidgets = useWidgetStore((s) => s.clearItemWidgets);
  const itemHasOneMan = useWidgetStore((s) => s.itemHasOneMan);

  const [hasOneMan, setHasOneMan] = useState<boolean>(itemHasOneMan(item.id));

  useEffect(() => {
    setPopupProperties({
      style: {
        maxHeight: "80%",
        overflowY: "auto",
        maxWidth: 430,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [values, setValues] = useState<boolean[]>(
    Array(WIDGETS.length).fill(false)
  );

  useEffect(() => {
    let res: boolean[] = Array(WIDGETS.length).fill(false);

    WIDGETS.forEach((w, i) => {
      item.widgets.forEach((_w) => {
        if (w.name === _w.name) res[i] = true;
      });
    });

    setValues(res);
  }, [item]);

  const setCheckBoxValue = (wn: string, value: boolean, idx: number): void => {
    const widget = getWidgetByName(wn);

    if (value) {
      if (hasOneMan) {
        return;
      }
      if (widget && widget.oneMan) {
        clearItemWidgets(item.id);
        addWidgetToItem(wn, item.id);
        setValues((prev) => {
          prev = prev.map((_, i) => i === idx);
          return [...prev];
        });
        setHasOneMan(true);
        return;
      }

      addWidgetToItem(wn, item.id);
      setValues((prev) => {
        prev[idx] = true;
        return [...prev];
      });
    } else {
      if (widget && widget.oneMan) {
        setHasOneMan(false);
      }
      rmWidgetFromItem(wn, item.id);
      setValues((prev) => {
        prev[idx] = false;
        return [...prev];
      });
    }
  };

  return (
    <Column style={{ position: "relative" }}>
      <PopupClose />

      <Heading
        color={theme.textOnOverlay}
        textStyles={{ margin: "1rem" }}
        size={16}
      >
        ویجت های انتخاب شده :
      </Heading>

      <Column
        style={{ width: "calc(100% - 2rem)", marginBottom: "1rem" }}
        gap={10}
        alignItems={AlignItems.Start}
      >
        {WIDGETS.map((w, i) => (
          <CheckBox
            key={w.name}
            color={theme.textOnOverlay}
            label={`${w.name}${
              w.oneMan ? " (فقط تنها می تواند استفاده شود)" : ""
            }`}
            value={values[i]}
            setValue={(v) => setCheckBoxValue(w.name, v, i)}
          />
        ))}
      </Column>
    </Column>
  );
};

export default SelectComponents;
